import { RealtimeClient } from "./RealtimeClient";
import { RestClient } from "./restClient";

export class FeedService {
	constructor(options) {
		this._options = options;
		this._rc = new RealtimeClient();
		this._restClient = new RestClient();
	}

	getUserFeedEntityListByType(type, callback) {
		const url = `/ecosystem/api/feeds/search-by-type/${type}`;
		this._restClient.exec_get(url, callback);
	}

	getFeedEntitiesByIds(entityIds, callback) {
		const joinedIds = entityIds.join(",");
		const url = `/ecosystem/api/feeds/authorize/${joinedIds}`;
		this._restClient.exec_get(url, callback);
	}

	setFeedEntityActiveStatus(entityType, entityId, isActive, callback) {
		const url = `/ecosystem/api/feedEntities/${entityType}/${entityId}/activeStatus/${isActive}`;
		this._restClient.exec_post(url, null, callback);
	}

	subscribeFeed(feedId, callback) {
		return this.subscribeFilteredFeed("system", feedId, null, callback);
	}

	subscribeExternalFeed(feedId, callback) {
		return this.subscribeFilteredFeed("external", feedId, null, callback);
	}

	subscribeGlobalFeed(feedId, callback) {
		return this.subscribeFilteredFeed("global", feedId, null, callback);
	}

	// -- replacing inclusionGeo with options which will include additional options like inclusionGeo, expandRefs
	/*	@param: ignoreBatches -- Boolean: Ignore batch types from sys_feedTypes and send across all entities, un-batched
	 *	@param: excludeEntities -- Array: Ignore these entityIds when choosing what to stream
	 */
	subscribeFilteredFeed(filterType, feedId, options, callback, ignoreBatches, excludeEntities = null) {
		let inclusionGeo = null;
		let expandRefs = null;
		if (options) {
			inclusionGeo = options.coordinates ? options : options.inclusionGeo; // backward compatibility
			expandRefs = options.expandRefs || false;
		}
		const args = {
			filterType: filterType,
			feedId: feedId,
			inclusionGeo: inclusionGeo,
			expandRefs: expandRefs,
			ignoreBatches: ignoreBatches,
			excludeEntities: excludeEntities
		};
		// -- returns promise that will resolve to channel that can be used for unsubscribe
		return this._rc.subscribe("ecosystem", "/feedEntities", args, function (msg) {
			const response = JSON.parse(msg);
			if (response) {
				if (callback) {
					callback(null, response);
				}
			}
		});
	}

	getUserIntegration(userId, callback) {
		const url = "/ecosystem/api/users/user/integrations";
		this._restClient.exec_get(url, callback);
	}

	getUserAppIntegration(userId, appId, callback) {
		const url = `/ecosystem/api/users/user/integrations/${appId}`;
		this._restClient.exec_get(url, callback);
	}

	streamUserIntegration(userId, callback) {
		const args = {
			filterType: "initial-by-feed",
			userId: userId
		};

		return this._rc.subscribe("ecosystem", "/userIntegration", args, function (msg) {
			const response = JSON.parse(msg);
			if (response) {
				if (callback) {
					callback(null, response);
				}
			}
		});
	}

	streamUserAppIntegration(userId, appId, callback) {
		const args = {
			filterType: "initial-by-feed",
			userId: userId,
			appId
		};

		return this._rc.subscribe("ecosystem", "/userAppIntegration", args, function (msg) {
			const response = JSON.parse(msg);
			if (response) {
				if (callback) {
					callback(null, response);
				}
			}
		});
	}

	streamEntityByType(entityId, entityType, callback) {
		const args = {
			filterType: "initial-by-entity",
			entityId: entityId,
			entityType: entityType
		};

		return this._rc.subscribe("ecosystem", "/entity", args, function (msg) {
			const response = JSON.parse(msg);
			if (response) {
				if (callback) {
					callback(null, response);
				}
			}
		});
	}

	updateEntity(entityId, entityType, data, callback) {
		const url = `/ecosystem/api/feeds/${entityType}/${entityId}`;
		const body = JSON.stringify(data);
		this._restClient.exec_put(url, body, callback);
	}
}
